export enum EComponentId {
  SystemOverview,
  PlateLoadPort,
  PlateSearch,
  ImagerLiveImage,
  ImagerEfi,
  ImagerDropLocation,
  ImagerFocusGraph,
  ImagerLastCaptured,
  Schedule,
  Temperature,
  PlateSetupPlateTypeCalibration,
  PlateSetupDefImgSetting,
  PlateSetupImageMask,
  ToolsStoreAndRetrieve,
  ToolsGeneral,
  ToolsEmail,
  ToolsTesting,
  ToolsSimulation,
  SettingsVectorEditor,
  SettingsImager,
  SettingsStorage,
  SettingsPsrCamera,
  SettingsSystemBackup,
  SettingsPreferences,
  ReportAndSupportEventLog,
  ReportAndSupportLicensing,
  ReportAndSupportUserManagement,
}

export interface ComponentPermission {
  componentId: EComponentId;
  read: boolean;
  write: boolean;
}

export interface PermissionContext {
  permissions: ComponentPermission[];
}

export interface PermissionProps {
  permissions?: ComponentPermission[];
  componentId?: EComponentId;
}
